<template>
<div>
  <el-row type="flex" class="title-bar" justify="space-between">
    <w-perf-analysis-time-info v-if="!operationFlag" :ref="timeInfoRef" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataReLoad"/>
    <w-header-search-button @click="onShowSearchToolButtonClick"></w-header-search-button>
  </el-row>
  <el-row>
  <el-table-wrapper v-loading="loading" border :data="tableData" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool" ref="table" style="width:100%;"  :show-overflow-tooltip="true" :span-method="objectSpanMethod"
  :pagination="false" :column-default="columnDefault">
  </el-table-wrapper>
  </el-row>
</div>
</template>
<script>
import msgUtil from '@/utils/message';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { analysisTimeType } from '@/constants/performance';
import { columnDefault } from '@/constants/table';
import netdeviceTableInfoAPI from '@/api/performance/netdevice/netdevice-table-info';
import analysisTableMixin from '@/mixins/performance/analysis-table-ex';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';

export default {
  name: 'WConnectionDeviceTable',
  mixins: [analysisTableMixin],
  components: {
    WPerfAnalysisTimeInfo,
  },
  data() {
    return {
      checkDatetime: null,
      loading: false,
      tableData: [],
      columnDefault,
      columns: [
        { prop: 'interfaceName', label: '인터페이스 명', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty, className: 'rowspan' },
        { prop: 'objName', label: '장비명', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'ipaddress', label: 'IP주소', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'macaddress', label: 'MAC', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'companyName', label: 'NIC 제조사', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
      ],
      showSearchTool: false,
    };
  },
  methods: {
    /**
     * 연결 장비 정보를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      const params = {
        objId: this.selectedNode.obj.objId,
      };
      if (this.timeType === analysisTimeType.HIST.value && !this.operationFlag) {
        params.baselineDatetime = this.plotLineDatetime;
        params.managetypeId = 'NMS';

        this.loading = true;
        netdeviceTableInfoAPI.getConnectionDeviceList(params).then((response) => {
          if (response.data.success === true) {
            const snapshotData = response.data.data;
            this.tableData = snapshotData.snapshotDoc;
            this.checkDatetime = snapshotData.timestamp;
          } else {
            this.failToLoad();
          }
        }).catch(() => {
          this.failToLoad();
        }).finally(() => {
          this.loading = false;
        });
      } else {
        this.loading = true;
        netdeviceTableInfoAPI.getCurrentConnectionDeviceList(params).then((response) => {
          if (response.data.success === true) {
            this.tableData = response.data.data;
          } else {
            this.failToLoad();
          }
        }).catch(() => {
          this.failToLoad();
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    /**
     * 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoad() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '연결 장비', false));
    },
    /**
     * [objectSpanMethod 병합 메서드]
     * @author {Yang}
     * @param  {[type]} row         [description]
     * @param  {[type]} columnIndex [description]
     * @param  {[type]} }           [description]
     * @return {[type]}             [description]
     */
    objectSpanMethod({ row, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        let count = 0;
        let firstFlag = true;
        for (let i = this.tableData.length - 1; i >= 0; i -= 1) {
          if (row.interfaceName === this.tableData[i].interfaceName) {
            if (i >= rowIndex) {
              count += 1;
            } else {
              firstFlag = false;
            }
          }
        }
        if (firstFlag && count === 1) {
          return [1, 1];
        }
        if (!firstFlag) {
          return [0, 0];
        }
        return [count, 1];
      }
      return [1, 1];
    },
    onShowSearchToolButtonClick() {
      this.showSearchTool = !this.showSearchTool;
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/netdevice/components/table/ConnectionDeviceTable.vue